import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BaseFieldComponent } from '../base-field.component';

@Component({
    selector: 'app-task-list-field',
    imports: [IonicModule, FormsModule],
    template: `
        @if (readonly) {
            <div class="task-list-readonly">
                <ion-label class="task-label">{{ field.label }}</ion-label>
                @if (taskItems.length === 0) {
                    <ion-item lines="none">
                        <ion-label color="medium">Geen taken</ion-label>
                    </ion-item>
                } @else {
                    <ion-list class="task-items">
                        @for (task of taskItems; track $index) {
                            <ion-item lines="none">
                                <ion-icon name="checkmark-circle-outline" slot="start" color="medium"></ion-icon>
                                <ion-label>{{ task }}</ion-label>
                            </ion-item>
                        }
                    </ion-list>
                }
            </div>
        } @else {
            <div class="task-list-field">
                <ion-label class="task-label">{{ field.label }}</ion-label>
                @if (field.helpText) {
                    <ion-note class="field-help">{{ field.helpText }}</ion-note>
                }

                <div class="task-input-row">
                    <ion-input
                        [placeholder]="field.placeholder || 'Nieuwe taak...'"
                        [(ngModel)]="newTaskInput"
                        (keyup.enter)="addTask()">
                    </ion-input>
                    <ion-button fill="clear" (click)="addTask()">
                        <ion-icon name="add-circle-outline"></ion-icon>
                    </ion-button>
                </div>

                <ion-list class="task-items">
                    @for (task of taskItems; track $index) {
                        <ion-item>
                            <ion-label>{{ task }}</ion-label>
                            <ion-button fill="clear" slot="end" color="danger" (click)="removeTask($index)">
                                <ion-icon name="trash-outline"></ion-icon>
                            </ion-button>
                        </ion-item>
                    }
                </ion-list>
            </div>
        }
    `,
    styles: [`
        .task-list-field, .task-list-readonly {
            padding: 16px;
        }

        .task-label {
            display: block;
            font-weight: 500;
            margin-bottom: 8px;
        }

        .field-help {
            display: block;
            padding: 4px 0;
            font-size: 12px;
            margin-bottom: 8px;
        }

        .task-input-row {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .task-input-row ion-input {
            flex: 1;
        }

        .task-items {
            margin-top: 8px;
        }
    `]
})
export class TaskListFieldComponent extends BaseFieldComponent {
    taskItems: string[] = [];
    newTaskInput = '';

    initialize(value: any): void {
        if (Array.isArray(value)) {
            this.taskItems = [...value];
        } else if (typeof value === 'string' && value) {
            try {
                const parsed = JSON.parse(value);
                this.taskItems = Array.isArray(parsed) ? parsed : [];
            } catch {
                this.taskItems = [];
            }
        } else {
            this.taskItems = [];
        }
    }

    serialize(): any {
        return this.taskItems;
    }

    addTask(): void {
        if (this.newTaskInput.trim()) {
            this.taskItems.push(this.newTaskInput.trim());
            this.newTaskInput = '';
            this.emitChange(this.taskItems);
        }
    }

    removeTask(index: number): void {
        this.taskItems.splice(index, 1);
        this.emitChange(this.taskItems);
    }
}
